import { render, staticRenderFns } from "./investor.vue?vue&type=template&id=5692a04e&"
import script from "./investor.vue?vue&type=script&lang=js&"
export * from "./investor.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./investor.vue?vue&type=style&index=1&id=5692a04e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports